export default __webpack_public_path__ + "static/media/add-new-pet.27944432.png";